import React from 'react';
import './ShowMoreButton.scss';
import { faPlus, faMinus } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIconWrapper } from "/react4xp/components/FontAwesomeIconWrapper";
import { Button } from '../../components/Button';


export function ShowMoreButton({onToggle, isOpen, ariaId}: { onToggle: () => void, isOpen: boolean, ariaId: string }): React.JSX.Element {

	const handleEnterOrSpace = (e: React.KeyboardEvent<HTMLButtonElement>): void => {
		if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
			e.preventDefault();
			e.stopPropagation();
			onToggle();
		}
	};

	const ShowMoreButtonContent = ({ isOpen }: { isOpen: boolean }):React.JSX.Element => {
		return (
			<span className="show-more-button__button--content">
				<FontAwesomeIconWrapper icon={isOpen ? faMinus : faPlus} />
				{isOpen ? "Vis færre varsler" : "Vis flere varsler"}
			</span>
		);
	};

	return (
		<div className="show-more-button">
			<span className="show-more-button__divider"/>
			<Button
				className="show-more-button__button"
				variant="secondary"
				size="large"
				onClick={onToggle}
				onKeyDown={handleEnterOrSpace}
				aria-expanded={isOpen}
				aria-controls={ariaId}
			>
				<ShowMoreButtonContent isOpen={isOpen} />
			</Button>
			<span className="show-more-button__divider"/>
		</div>
	);
}
